import { BulkReducerState } from './types';

export const getDefaultState = (): BulkReducerState => ({
  allIds: [],
  pageIds: [],
  isAllSelected: false,
  selectedIds: []
});
